import styled, { keyframes } from 'styled-components';

const wave = keyframes`
  0% {
    transform: translateX(-100%);
  }
  60% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

export const Skeleton = styled.span`
  display: block;
  position: relative;
  overflow: hidden;
  background-color: #fff;
  border: 1.5px solid;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
  border-color: #f2f2f2;
  height: 48px;

  &:after {
    animation: ${wave} 1.6s linear 0.5s infinite;
    background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.10), transparent);
    content: "";
    position: absolute;
    transform: translateX(-100%);
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }
`;
